import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import BasicApp from 'app/components/root-apps/basic-app';
import {
  baseMapStateToProps,
  baseNoAuthMapDispatchToProps,
  baseNoAuthPreload,
} from 'app/common/containers/base';
import { fetchGlowforgeLandingPage } from 'app/api/landing-api';
import { fetchProducts } from 'app/store/api/glowforge-store-api';
import { fetchReferral } from 'app/common/api/common-api';
import clientPreload from 'app/common/containers/client-preload';


const mapDispatchToProps = (dispatch) => {
  const { clientPreloads: clientPreloadBase, ...base } = baseNoAuthMapDispatchToProps(dispatch);
  // merge client preloads
  const clientPreloads = [
    ...clientPreloadBase,
    () => dispatch(fetchReferral()),
  ];
  return {
    ...base,
    clientPreloads,
  };
};

const AppContainer = connect(baseMapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, getState }) =>
    baseNoAuthPreload(dispatch, getState()).concat([
      dispatch(fetchProducts()),
      dispatch(fetchGlowforgeLandingPage()),
    ]))(clientPreload(BasicApp)),
);

export default AppContainer;



// WEBPACK FOOTER //
// ./app/containers/landing/landing-app.jsx